import React from 'react';
import {
    Link
} from "react-router-dom";

const item = (props) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <p className="each-cartitem-label">Group Deal</p>
            </div>
            <div className="col-12 col-sm-5 col-lg-6 col-md-6">
                <div className="d-lg-flex d-md-flex d-mob-flex">
                    <div className="cart-image-outer-col">
                        <img src={props.item.deal.image} alt={props.item.deal.name}/>
                    </div>
                    <div className="cart-info-sec">
                        <p className="cart-deal-sec-text text_color_green">{props.item.deal.category.name}</p>
                        <p className="cart-deal-sec-text custom-height">{props.item.deal.name}</p>
                        <p className="cart-deal-sec1-text custom-height">{props.item.deal.subtitle}</p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-sm-7 col-lg-6 col-md-6 pl-lg-0 pp-margin-top">
                <div className="column--large">
                    <div className="date-cart-width">
                        <span className="mycart-deal--price-text width-50 mr-0">Capacity : </span>
                        <span className="mycart-deal--price-text width-50 mr-0">{props.item.deal.capacity}</span>
                    </div>
                    <div className="date-cart-width">
                        <span className="date_label width-50 mr-0">Date:</span>
                        <div className=" width-50">
                            <input type="text" className="custom-datepicker" readOnly placeholder="DD/MM/YYYY" value={props.item.deal.dealdate}/>
                                <span className="input-group-append"><button
                                    className="btn btn-outline-secondary border-left-0" type="button"
                                    data-toggle="modal" data-target={"#exampleModalCenter_"+props.item.deal._id}><i
                                    className="fa fa-calendar fa-sb-icon"></i></button></span>
                        </div>
                    </div>
                    <div className="modal fade h-auto" id={"exampleModalCenter_"+props.item.deal._id} tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content custom-date-modal">
                                <div className="modal-header">
                                    {props.item.deal.other_date_deals.length ?
                                        <h5 className="modal-title pl-0 payment-modal-text">Select Date</h5>
                                        :
                                        <p className="pl-0 payment-modal-text mb-0 text-white">This deal is valid only for this date</p>
                                    }
                                    <button type="button" className="close ml-0" data-dismiss="modal"
                                            aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                {props.item.deal.other_date_deals.length ?
                                <div className="modal-body">
                                    <form autoComplete="off" action="" className="group-date-pick">
                                        {props.item.deal.other_date_deals.map(other_deal =>
                                            <label key={other_deal._id} className="container">{other_deal.dealdate}
                                                <input data-dismiss="modal"
                                                       onClick={(event) => props.handleOtherDate(event, props.item._id)}
                                                       type="radio" name="radio" value={other_deal._id}/>
                                                <span className="checkmark2"></span>
                                            </label>
                                        )}
                                    </form>
                                </div> : null }
                            </div>
                        </div>
                    </div>
                    <div className="mycart-deal--price d-flex">
                        <span className="mycart-deal--price-text width-50 mr-0">Deal price :</span>
                        <span className="mycart-deal--price-text text_color_green width-50 mr-0">${props.item.deal.consumer_order_cost}</span>
                    </div>
                    <div className="cart-page-btn mt-3 d-flex">
                        <div className="delete-btn-col d-inline-block">
                            <button onClick={() => props.handleRemoveCartItem(props.item._id)} type="button" className="btn--del w-auto"><i className="fa fa-trash-o mr-2" aria-hidden="true"></i>Delete
                            </button>
                        </div>
                        <Link to={process.env.PUBLIC_URL+'/oneday/deal/'+props.item.deal._id} className="grad-on cart-view-btn"><i className="fa fa-eye mr-2" aria-hidden="true"></i>View Details</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default item;